import React, { useEffect, useState } from 'react';
import ClientInvestmentGrid from './ClientInvestmentGrid';
import axios from 'axios';
import StatusDropdown from '../../shared/common-dropdown/StatusDropdown';
import UsersDropdown from '../../shared/common-dropdown/UserDropdown';
import PriorityDropdown from '../../shared/common-dropdown/PriorityDropdown';
import TitleDropdown from '../../shared/common-dropdown/TitleDropdown';
import ClientDropdown from '../../shared/common-dropdown/ClientDropdown';
import ClientCompanyTypeDropdown from '../../shared/common-dropdown/ClientCompanyTypeDropdown';
import * as Icons from "react-feather";
import { getStorageValues } from '../../shared/CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';

function AddTask({ sendDataToParent }) {
  const [getClientCompany, setClientCompany] = useState([]);
  const [allClientCompanies, setAllClientCompanies] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);

  // handle change events for form fields
  function handleChange(e) {
    const { name, value } = e.currentTarget;
    sendDataToParent((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  // main dropdown logic
  function handleDropdownChange(selectedOption, e) {
    if (e.name === "ClientId") {
      sendDataToParent((prevState) => ({
        ...prevState,
        ClientId: selectedOption ? selectedOption.value : null,
      }));
      if (!selectedOption) setClientCompany([]);
    } else if (e.name === "AssignedToUserId") {
      sendDataToParent((prevState) => ({
        ...prevState,
        AssignedToUserId: selectedOption ? selectedOption.value : null,
      }));
    } else if (e.name === "PriorityId") {
      sendDataToParent((prevState) => ({
        ...prevState,
        PriorityId: selectedOption ? selectedOption.value : null,
      }));
    } else if (e.name === "StatusId") {
      sendDataToParent((prevState) => ({
        ...prevState,
        StatusId: selectedOption ? selectedOption.value : null,
      }));
    } else if (e.name === "TitleId") {
      sendDataToParent((prevState) => ({
        ...prevState,
        TitleId: selectedOption ? selectedOption.value : null,
      }));
    } else if (e.name === "ClientCompanyTypeId") {
      sendDataToParent((prevState) => ({
        ...prevState,
        ClientCompanyTypeId: selectedOption ? selectedOption.value : null,
      }));
      if (selectedOption !== null) {
        fetchClientCompany(selectedOption.value);
      } else {
        setClientCompany([]);
        setAllClientCompanies([]);
      }
    }
  }

  // fetch companies
  const fetchClientCompany = async (clientCompanyTypeId) => {
    try {
      let ClientCompanyDetails = {
        UserId: getStorageValues('userId'),
        ClientCompanyTypeId: clientCompanyTypeId
      };
      const response = await axios.get(getApiBaseUrl() + "/clientCompanybytype", {
        params: ClientCompanyDetails
      });
      if (response.status === 200) {
        const data = response.data.data[0] || [];
        setClientCompany(data);
        setAllClientCompanies(data); // <-- keep full copy
      }
    } catch (error) {
      console.log(error);
    }
  };

  // filter function (works even when typing backspace)
  function onChangeFilterText(e) {
    const searchValue = e.target.value.toLowerCase();
    setFilterText(searchValue);

    if (!searchValue.trim()) {
      // restore full list when input cleared
      setClientCompany(allClientCompanies);
      return;
    }

    const filteredRows = allClientCompanies.filter(
      (item) =>
        item.ClientCompanyName &&
        item.ClientCompanyName.toLowerCase().includes(searchValue)
    );

    setClientCompany(filteredRows);
  }

  // selected rows handlers
  function onSelectedRowChange(e, rowIndex, column) {
    const RowData = [...getClientCompany];
    RowData[rowIndex][column] = e.target.value;
    setClientCompany(RowData);
    const selectedRowData = RowData.filter(item =>
      selectedRows.some(filterItem => filterItem.ClientCompanyId === item.ClientCompanyId)
    );
    sendDataToParent((prevState) => ({
      ...prevState,
      SelectedCompanies: selectedRowData
    }));
  }

  function onRowSelected(state) {
    setSelectedRows(state.selectedRows);
    sendDataToParent((prevState) => ({
      ...prevState,
      SelectedCompanies: state.selectedRows || []
    }));
  }

  useEffect(() => {}, []);

  return (
    <>
      <div className="row">
        {/* TITLE DROPDOWN */}
        <div className="col-lg-12 col-sm-6 col-12">
          <div className="input-blocks1 mb-3">
            <TitleDropdown
              modelName="TitleId"
              required={true}
              onChangeDropdown={handleDropdownChange}
              placeholder={"Type to create new title or search existing"} />
          </div>
        </div>

        {/* CLIENT DROPDOWN */}
        <div className="col-lg-12 col-sm-6 col-12">
          <div className="input-blocks1 mb-3">
            <ClientDropdown modelName="ClientId" onChangeDropdown={handleDropdownChange} />
          </div>
        </div>

        {/* GRID SECTION */}
        <div className="col-lg-12 col-sm-6 col-12">
          <div className="card">
            <div className="card-header task-client-investment-grid-header">
              <div className="row">
                <div className="col-lg-6 col-sm-6 col-12">
                  <ClientCompanyTypeDropdown showTitle={false} onChangeDropdown={handleDropdownChange} />
                </div>
                <div className="col-lg-6 col-sm-6 col-12 d-flex justify-content-end">
                  <div className="search-set">
                    <div className="search-input">
                      <button type="button" className="btn btn-searchset">
                        <Icons.Search className="feather-search" />
                      </button>
                      <input
                        id="search"
                        type="text"
                        className="form-control form-control-sm custom-search-input"
                        placeholder="Search"
                        aria-label="Search Input"
                        value={filterText}
                        onChange={onChangeFilterText}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body task-client-investment-grid-body" style={{ maxHeight: "240px",overflowY: "auto",padding: "0.5rem"}}>
              <ClientInvestmentGrid
                ClientInvestmentData={getClientCompany}
                onSelectedRowChange={onSelectedRowChange}
                onRowSelected={onRowSelected}
                filterText={filterText}
              />
            </div>
          </div>
        </div>

        {/* ADDITIONAL DROPDOWNS */}
        <div className="col-lg-4 col-sm-4 col-12">
          <div className="input-blocks1 mb-3">
            <UsersDropdown modelName="AssignedToUserId" required={true} onChangeDropdown={handleDropdownChange} />
          </div>
        </div>
        <div className="col-lg-4 col-sm-4 col-12">
          <div className="input-blocks1 mb-3">
            <PriorityDropdown modelName="PriorityId" required={true} onChangeDropdown={handleDropdownChange} />
          </div>
        </div>
        <div className="col-lg-4 col-sm-4 col-12">
          <div className="input-blocks1 mb-3">
            <StatusDropdown required={true} onChangeDropdown={handleDropdownChange} />
          </div>
        </div>

        {/* DESCRIPTION */}
        <div className="col-lg-12 col-sm-6 col-12">
          <div className="summer-description-box transfer mb-3">
            <label className="form-label">Description</label>
            <textarea
              className="form-control h-100"
              rows="2"
              name="Description"
              onChange={handleChange}
            />
            <p className="mt-1">Maximum 1000 Characters</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddTask;
